<template>
  <div>
    <v-dialog v-model="show" width="500" persistent scrollable>
      <v-card>
        <v-card-title class="headline">Create Template</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert
            v-if="isDefault"
            :value="true"
            color="info"
            icon="info"
            outline
          >
            You are editing a default template, so you need to add another
          </v-alert>
          <v-form @submit.prevent="save">
            <v-text-field
              v-model="name"
              :counter="190"
              label="Name (*)"
              required
            ></v-text-field>
            <v-select
              :items="types"
              label="Type"
              v-model="type"
            ></v-select>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="$emit('close-modal-create-template')">Close</v-btn>
          <v-btn color="primary" @click="save">Save</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    templateType: {
      type: String,
      required: true
    },
    isDefault: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      name: '',
      types: ['SENDER', 'REMINDER'],
      type: 'SENDER',
    };
  },
  watch: {
    show: function () {
      this.type = this.types[this.templateType];
      this.name = '';
    }
  },
  mounted () {
    this.type = this.types[this.templateType];
    this.name = '';
  },
  methods: {
    ...mapActions(['setSnackbar', 'setLoading']),
    save () {
      let payload = {
        name: this.name,
        type: this.type
      };
      this.setLoading(true);
      window.axios.post('/templates', payload).then(response => {
        this.setLoading(false);
        this.$emit('add-template', response.data.data);
        this.$emit('close-modal-create-template');
        this.setSnackbar({
          show: true,
          color: 'success',
          text: 'Template saved'
        });
        
      }).catch(error => {
        this.setLoading(false);
        this.setSnackbar({
          show: true,
          color: 'red',
          text: 'Error saved Template'
        });
        this.setLoading(false);
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/client/templates/modals/Create.vue